import React, { Component } from 'react';

export class Kangeiko2019 extends Component {
    render() {
        return (
        <div class="container page-content">
            <div class="page-header">
                <h2>Kangeiko 2019</h2> 
            </div>
            <hr class="hrNeonBlue" />
            <p class="lead">Cher amis ISKF, nous aurons l’honneur de recevoir <strong>Shihan Hiroyoshi Okazaki 9e Dan</strong> dans le cadre du prochain camp d’hiver, le QUÉBEC KANGEIKO 2019 du <strong>14 au 17 mars prochain.</strong></p>
            <article>
                <h1>Informations</h1>
                <p>Le dojo Québec Shotokan sera l’hôte de cet important évènement de Québec ISKF.</p>
                <p>De plus, la <strong>Grande Soirée de campagne de financement</strong> de notre organisation provinciale, le <span class="redText">SHOTOSHOW</span>, aura lieu au Grand Café le samedi 16 mars à compter du 18h00 au profit de nos compétiteurs pour le Championnat National 2019 à Calgary.</p>
                <p class="paddedLink"><a href="/pdf/news/HoraireKangeiko2019.pdf">Télécharger l'horaire complet du Kangeiko!</a></p>
                <p>Nous espérons vous accueillir tous, jeunes et adultes, débutants ou avancés, à ces deux évènements d’importances afin de resserrer nos liens d’amitié et le plaisir d’être ensemble. Les années passent et nous sommes toujours présents grâce à cette passion commune du karaté shotokan qui nous unit.</p>
                
                <p><strong>Au plaisir de vous voir à votre Kangeiko!</strong></p>
                <p><strong>OSU!</strong></p>

                <img class="responsive-centered-img" src="/images/news/Hiroyoshi.jpg" alt="Shihan Hiroyoshi Okazaki 9e Dan"/>
            </article>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/pages/nouvelles/Kangeiko2019.js